import {
  isEmpty
} from "lodash";

export function setConfigItemListState(parentId, statePropName, page, excludedValues) {
  if (
    !isEmpty(page.props.configItems.configItemByParent[parentId]) &&
        page.state[statePropName].length === 0
  ) {
    const listItems = page.props.configItems.configItemByParent[parentId].filter(x => !excludedValues || !excludedValues.includes(x.id));
    page.setState({
      ...page.state,
      [statePropName]: listItems.map(
        item => ({
          value: item.id,
          label: item.name
        })
      )
    });
  }
}

export function setEnumeratedTypesListState(type, statePropName, page, excludedValues, shouldSort, shouldSortAlphabetically, refresh) {
  if (
    !isEmpty(page.props.enumeratedTypes[type]) &&
        (page.state[statePropName].length === 0 || refresh)
  ) {
    const listItems = page.props.enumeratedTypes[type].filter(x => !excludedValues || !excludedValues.includes(x.id));
    if (shouldSort) {
      page.setState({
        ...page.state,
        [statePropName]: listItems.sort((a, b) => a.sortOrder - b.sortOrder).map(
          item => ({
            value: item.id,
            label: item.name || item.value
          })
        )
      });
    } else if (shouldSortAlphabetically) {
      page.setState({
        ...page.state,
        [statePropName]: listItems.sort((a, b) => {
          if (a.name) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
          } else if (a.value) {
            if (a.value < b.value) {
              return -1;
            }
            if (a.value > b.value) {
              return 1;
            }
          }

          return 0;
        }).map(
          item => ({
            value: item.id,
            label: item.name || item.value
          })
        )
      });
    } else {
      page.setState({
        ...page.state,
        [statePropName]: listItems.map(
          item => ({
            value: item.id,
            label: item.name || item.value
          })
        )
      });
    }
  }
}
